import { useRouter } from './useRouter';
import { useMemo } from 'react';
export function useQueryString(name) {
    var location = useRouter().location;
    return useMemo(function () {
        var query = new URLSearchParams(location.search);
        return query.get(name);
    }, [name, location.search]);
}
//# sourceMappingURL=useQueryString.js.map